module.exports = __webpack_public_path__ + "img/powered-by-rectangle-green.08392f18.svg";